import {createSelector} from "@reduxjs/toolkit";
import {RootState} from "../../../helpers/store";

const loadingNumber = (state: RootState, props: any) => state.loading.loading;

export const isLoadingSelector = createSelector([loadingNumber], (loading: number) => loading > 0);
